import React from 'react';
import moment from 'moment';
// import DateRangePicker from "react-bootstrap-daterangepicker";
import { Glyphicon } from 'react-bootstrap';
import '../assets/css/bootstrap-glyphicons.css';
import DateRangePicker from 'react-daterange-picker';
import { endOfMonth, last2years } from '../helpers/constants';
import 'react-daterange-picker/dist/css/react-calendar.css';
import '../assets/css/date-range-picker.css';
import 'moment/locale/ar';
import 'moment/min/locales';
import { changeLocalesMyMm } from '../helpers/translations/config';
import {
  clearLS, getLS, removeLS, setLS,
} from '../helpers/utils';

class DateRangeFilter extends React.Component {
  constructor(props) {
    super(props);

    // eslint-disable-next-line react/destructuring-assignment
    const fromDate = this.props.from;
    // eslint-disable-next-line react/destructuring-assignment
    const toDate = this.props.to;
    this.state = {
      locale: null,
      fromDate,
      toDate,
      // eslint-disable-next-line react/no-unused-state
      compareApplied: false,
      // eslint-disable-next-line react/no-unused-state
      dates: null,
      isOpen: false,
      // eslint-disable-next-line react/destructuring-assignment
      value: moment.range(moment(fromDate).clone().locale(changeLocalesMyMm(this.props.locale)), moment(toDate).clone().locale(changeLocalesMyMm(this.props.locale))),
    };
  }

  onSelect = (value, states) => {
    const _start = moment(value.start).locale('en');
    const _end = moment(value.end).locale('en');
    const _startDate = (_start.format('YYYY-MM-DDT00:00:00.000'));
    const _endDate = (_end.format('YYYY-MM-DDT23:59:59.999'));

    this.setState({
      // eslint-disable-next-line react/no-unused-state
      value, states, isOpen: false, fromDate: _start, toDate: _end,
    });

    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.onDateRangeChange) {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.onDateRangeChange(_startDate, _endDate, this.props.filterAttribute);
    }
  };

  onToggle = () => {
    // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
    this.setState({ isOpen: !this.state.isOpen });
  };

  // eslint-disable-next-line react/destructuring-assignment
  renderSelectionValue = () => `${this.state.value.start.format('MMMM D, YYYY')} - ${this.state.value.end.format('MMMM D, YYYY')}`;

  // eslint-disable-next-line react/no-deprecated,react/sort-comp
  componentWillReceiveProps(nextProps) {
    // eslint-disable-next-line react/destructuring-assignment
    if (nextProps.locale !== this.state.locale) {
      this.setState({
        locale: changeLocalesMyMm(nextProps.locale),
        // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
        value: moment.range(moment(this.state.fromDate).clone().locale(changeLocalesMyMm(nextProps.locale)), moment(this.state.toDate).clone().locale(changeLocalesMyMm(nextProps.locale))),
      });
    }
  }

  render() {
    const {value}=this.state;
    const {locale}=this.props;

    return (
      <div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,react/destructuring-assignment */}
        <div id={this.props.id} className={this.props.className} onClick={this.onToggle} role="textbox" tabIndex={0}>
          {this.renderSelectionValue()}
          <Glyphicon
            glyph="glyphicon glyphicon-calendar pull-right ml-2"
          />
        </div>

        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.state.isOpen && (
          <DateRangePicker
            value={(value)}
            onSelect={this.onSelect}
            singleDateRange
            locale={changeLocalesMyMm(locale)}
            className={getLS('dark') === 'true' ? 'date-range-picker-dark' : 'date-range-picker-light'}
          />
        )}
        {/* <DateRangePicker
          startDate={this.state.fromDate}
          endDate={this.state.toDate}
          onApply={this.onApplyEvent.bind( this )}
        >
          <div>
            <div id={this.props.id} className={this.props.className}>

              <Glyphicon
                glyph="glyphicon glyphicon-calendar"
              />
&nbsp;
              <span>{this.dateRangeFormat( this.state.fromDate, this.state.toDate )}</span>
            </div>
          </div>
        </DateRangePicker> */}
      </div>
    );
  }
}

DateRangeFilter.defaultProps = {
  id: 'dateRangePicker',
  compare: false,
  from: last2years,
  to: endOfMonth, // moment(),
};

export default DateRangeFilter;
